<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">Delete User</h1>
    <div class="modal-description">
      <p class="warning-text">
        Are you sure you want to delete
        <strong class="user-name-highlight">'{{ data.username }}'</strong>?
        This action cannot be undone.
      </p>
      <div class="user-detail">
        <ul>
          <li>
            <span class="detail-label">User ID:</span>
            <span class="detail-value">{{ data.userId }}</span>
          </li>
          <li>
            <span class="detail-label">Username:</span>
            <span class="detail-value">{{ data.username || 'N/A' }}</span>
          </li>
          <li *ngIf="data.email">
            <span class="detail-label">Email:</span>
            <span class="detail-value">{{ data.email }}</span>
          </li>
          <li>
            <span class="detail-label">Customer ID:</span>
            <span class="detail-value">{{ data.customerId }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-container">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-delete" (click)="onConfirm()">Yes, Delete</button>
    </div>
  </div>
</div>
